import { Box, SxProps, useTheme } from "@mui/material";
import React from "react";

import { tierMap, TierType, UserType, userTypeMap } from "types/users";

// different type for the autocomplete state (requires null)
export type TierBadgeProps = {
  customerType: UserType | undefined;
  tier: TierType;
  isSuperuser: boolean;
  sx?: SxProps;
};

export function TierBadge(props: TierBadgeProps) {
  const { tier, customerType, isSuperuser, sx: sxProps } = props;
  const theme = useTheme();

  const TIER_COLORS = {
    FREE: { bgColor: "white", textColor: 'black' },
    PAID_1: { bgColor: "white", textColor: 'black' },
    PAID_2: { bgColor: "white", textColor: 'black' },
    AXON_INTERNAL: { bgColor: theme.palette.axon.main, textColor: 'black' },
    ENTERPRISE: { bgColor: "white", textColor: 'black' },
    CUSTOM: { bgColor: "white", textColor: 'black' },
    UNLIMITED: { bgColor: "white", textColor: 'black' },
  };

  const { bgColor, textColor } = TIER_COLORS[tier];

  const tierBadgeStyles: SxProps = {
    alignSelf: "flex-start",
    marginLeft: "5px",
    lineHeight: "10px",
    borderRadius: "50px",
    fontWeight: "700",
    fontSize: "10px",
    textTransform: "uppercase",
    padding: "2px 5px",
    backgroundColor: bgColor,
    color: textColor,
  };

  const sx = { ...tierBadgeStyles, ...sxProps };

  return (
    <>
      <Box sx={sx}>{tierMap[tier]}</Box>
      <Box sx={sx}>{userTypeMap[customerType || UserType.Customer]}</Box>
      {isSuperuser && <Box sx={sx}>Superuser</Box>}
    </>
  );
}
